export default __webpack_public_path__ + "static/media/Visual_joil_02.0375b529.jpg";